'use client';

import { FullStory } from './FullStory';
import { FullStoryCrossDomainSync } from './FullStoryCrossDomainSync';
import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';

import React from 'react';

export const FullStoryLoader: React.FC = () => {
  const { cloudPortalUserTelemetryCollection } = useFlagsProxy();

  if (process.env.FULLSTORY_ENABLED !== 'true') {
    return null;
  }

  if (!cloudPortalUserTelemetryCollection) {
    return null;
  }

  return (
    <>
      <FullStory />
      <FullStoryCrossDomainSync />
    </>
  );
};
